import hourglassPng from '/img/icons/hourglass.png';
import hourglassWebp from '/img/icons/hourglass.webp';

export const timeImages = {
  hourglass: {
    png: hourglassPng,
    webp: hourglassWebp,
  },
};
